let routerUtil = {
    setParam: (value) => {
        sessionStorage.setItem('_routerParam', JSON.stringify(value))
    },
    getParam: () => {
      return JSON.parse(sessionStorage.getItem('_routerParam'))
    },
    setParamStr: (value) => {
        sessionStorage.setItem('_routerParam', value)
    },
    getParamStr: () => {
        sessionStorage.getItem('_routerParam')
    },
    clearParam: () => {
        sessionStorage.removeItem('_routerParam')
    }
};
export default routerUtil